import styled from 'styled-components';
import dt from '../../../shared/theme';

const Tail = styled.p`
  margin: 0;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  > button {
    border: none;
    border-radius: 4px;
    height: 40px;
    width: 335px;
    text-transform: uppercase;
    font-family: ${props => dt(props).theme.fontFamilyBody};
    font-weight: ${props => dt(props).theme.fontWeightHeavy};
    font-size: 16px;
    line-height: 19px;
    outline: none;

    &.view-more {
      color: ${props => dt(props).theme.primaryColor};
      background: rgba(193, 157, 63, 0.1);
      &:hover:not([disabled]) {
        background-color: rgba(193, 157, 63, 0.2);
      }
      &[disabled] {
        background-color: rgba(193, 157, 63, 0.3);
      }
    }
  }
`;

export default Tail;
